import { Component } from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-recomendations-terapia-fisica',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgForOf
  ],
  templateUrl: './recomendations-terapia-fisica.component.html',
  styleUrl: './recomendations-terapia-fisica.component.css'
})
export class RecomendationsTerapiaFisicaComponent {

  motivos: any | [] = [
    {
      name: 'Aliviar el dolor crónico',
      imagen:'dolorCronicoIcon.svg'
    },
    {
      name: 'Recuperación de lesiones',
      imagen:'lesionesIcon.svg'
    },
    {
      name: 'Mejorar movilidad en Tercera Edad',
      imagen:'movilidadIcon.svg'
    },
    {
      name: 'Aliviar el estrés',
      imagen:'aliviarIcon.svg'
    },
    {
      name: 'Rehabilitación Post-quirúrgica',
      imagen:'rehabIcon.svg'
    }
    ]


}
